import React from 'react';
import { node } from 'prop-types';
import { CondensedLarge, Gutter, SectionHeader } from '@axiom/ui';

import { formatDataTestId } from '../../utils/data-test-util';
import { SIDEBAR_PADDING } from '../../themes/constants';

import { NoContentPlaceholderWrapper } from './NoContentPlaceholderStyles';

const NoContentPlaceholder = ({ image, text, title }) => (
  <NoContentPlaceholderWrapper
    data-test={formatDataTestId('no content placeholder')}
  >
    {image}
    <Gutter vertical="0.625rem">
      <SectionHeader name="TITLE">{title}</SectionHeader>
    </Gutter>
    <Gutter bottom={`${SIDEBAR_PADDING}`}>
      <CondensedLarge name="TEXT">{text}</CondensedLarge>
    </Gutter>
  </NoContentPlaceholderWrapper>
);

NoContentPlaceholder.defaultProps = {
  image: null,
};

NoContentPlaceholder.propTypes = {
  image: node,
  text: node.isRequired,
  title: node.isRequired,
};

export default NoContentPlaceholder;
